<template>
  <div class="error-page">
    <div class="header">
      <div class="row">
        <div class="columns">
          <img src="@/assets/moqo.svg" alt=""/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="columns">
        <h3>{{ error.status }} - {{ title }}</h3>
        <p>{{ description }}</p>
      </div>
    </div>

    <div class="row">
      <div class="columns text-center">
        <mq-navigation class="primary" :navItems="[
            { name: $t('footer.links.site_notice'), url: routes.siteNoticeUrl },
            { name: $t('footer.links.privacy_policy'), url: routes.privacyPolicyUrl }
          ]"></mq-navigation>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ErrorPage',

  props: {
    error: {
      type: Object,
      required: true
    }
  },

  computed: {
    title () {
      return this.$t(`errors.${this.errorCode}.title`)
    },

    errorCode () {
      if ([404, 500].indexOf(this.error.status) >= 0) {
        return this.error.status
      }
      return 500
    },

    description () {
      return this.$t(`errors.${this.errorCode}.description`)
    },
  }
}
</script>

<style lang="scss">
.error-page {
  height: 100vh;
  width: 100vw;
  background-color: white;

  .header {
    background-color: #363636;
    color: white;
    height: 80px;
    padding: 20px;
    div, img {
      height: 100%;
      max-height: 100%;
    }
  }

  h3 {
    margin-top: 100px;
    color: #363636;
  }

  p {
    font-size: rem-calc(14);
  }

  ul.navigation {
    list-style: none;
    text-align: center;
    width: auto;
    margin: auto;
    margin-top: rem-calc(60);

    li {
      display: inline-block;
      float: none;
      padding: 0 1em;
      margin: 0;

      @include breakpoint(medium down) {
        padding: 0 0.5em;
      }
    }

    a, router-link {
      text-transform: none;
      font-size: rem-calc(12);
      font-weight: $font-weight-regular;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue